import { Link } from "react-router-dom";
import Reveal from "@/components/base/Reveal";
import { worlds } from "@/mocks/site";

export default function WorldsIntro() {
  return (
    <section id="worlds" className="scroll-mt-24 bg-background-50">
      <div className="w-full px-5 md:px-10 lg:px-16 py-20 md:py-28">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <Reveal>
              <p className="eyebrow">Four Worlds · One Table</p>
            </Reveal>
            <Reveal delay={120}>
              <h2 className="mt-5 font-heading text-3xl leading-tight text-foreground-950 md:text-4xl">
                Not a portfolio.
                <br />
                <span className="italic text-primary-600">A place you enter.</span>
              </h2>
            </Reveal>
          </div>
          <div className="lg:col-span-7 lg:col-start-6">
            <Reveal delay={200}>
              <p className="font-body text-lg leading-relaxed text-foreground-700 md:text-xl">
                CHEF.TV is the home of Chef Eddie G — part culinary magazine,
                part travel journal, part cinematic portfolio. Four worlds
                connected by one idea: that food is how we find each other.
              </p>
            </Reveal>
          </div>
        </div>

        <div className="mt-16 border-t border-foreground-950/12">
          {worlds.map((world, i) => {
            const external = Boolean(world.external && world.href);
            const cardClass =
              "group grid grid-cols-1 items-center gap-5 border-b border-foreground-950/12 py-7 transition-colors duration-500 md:grid-cols-12 md:gap-8";
            const inner = (
              <>
                <div className="hidden h-20 w-20 overflow-hidden rounded-sm bg-foreground-900 md:col-span-1 md:block">
                  <img
                    src={world.image}
                    alt={world.title}
                    className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                  />
                </div>

                <div className="md:col-span-2">
                  <span className="font-heading text-2xl italic text-primary-500">
                    {world.no}
                  </span>
                  <span className="ml-3 font-label text-[10px] uppercase tracking-label text-foreground-500 md:ml-0 md:mt-1 md:block">
                    {world.kicker}
                  </span>
                </div>

                <h3 className="font-heading text-2xl leading-tight text-foreground-950 transition-transform duration-500 group-hover:translate-x-2 md:col-span-4 md:text-3xl">
                  {world.title}
                </h3>

                <p className="font-body text-sm leading-relaxed text-foreground-600 md:col-span-4">
                  {world.line}
                </p>

                <div className="md:col-span-1 md:justify-self-end">
                  <span className="flex h-11 w-11 items-center justify-center rounded-full border border-foreground-950/20 text-foreground-950 transition-all duration-500 group-hover:border-primary-500 group-hover:bg-primary-500 group-hover:text-background-50">
                    <i
                      className={
                        external
                          ? "ri-arrow-right-up-line text-lg"
                          : "ri-arrow-right-line text-lg"
                      }
                    />
                  </span>
                </div>
              </>
            );

            return (
              <Reveal key={world.no} delay={i * 90}>
                {external ? (
                  <a
                    href={world.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={cardClass}
                    title={world.cta}
                  >
                    {inner}
                  </a>
                ) : (
                  <Link to={world.to ?? "/"} className={cardClass} title={world.cta}>
                    {inner}
                  </Link>
                )}
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}